import React, { useContext, useState, useEffect } from 'react'
import { RootContext } from '../../../../context/rootContext'
import ReactGA from 'react-ga'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathToRegexp from 'path-to-regexp'

import * as S from './styles'
import { ReactComponent as LogoutIcon } from '../../../../assets/icons/arrow-right-from-bracket.svg'
import { getProfessionalCategory } from '../../../../utils/constants'
import { MENU_OPTIONS, vetRoutesPath } from './constants'

const SideMenu = () => {
  const pathname = window.location.pathname
  const { globalState, handleUpdateUserData } = useContext(RootContext)
  const [state] = globalState
  const [notificationsCount, setNotificationsCount] = useState(0)
  const isLogged = !!localStorage.getItem('userData')
  const { professional, partner } =
    isLogged && JSON.parse(localStorage.getItem('userData'))
  const professionalId = professional?.id
  const partnerId = partner
  const history = useHistory()
  const isFreelance = getProfessionalCategory() === 'FREELANCE'
  const isFranchising = getProfessionalCategory() === 'FRANCHISING'
  const hasMainProfessionalFranchising = professional?.mainProfessional?.category === 'FRANCHISING'
  const showNotificationItem = isFranchising || (isFreelance && hasMainProfessionalFranchising)

  useEffect(() => {
    const notifications = state.notificationsList
    const countNotifications = notifications.filter(notification => {
      const partnerData = notification?.partners.find(partner => partner.partner === partnerId && partner.professionals)
      const professionalData = partnerData?.professionals.find(prof => prof.professional === professionalId)
      return !professionalData?.read
    })
    setNotificationsCount(countNotifications.length)
  }, [state])

  const handleLogout = () => {
    localStorage.removeItem('userData')
    handleUpdateUserData(JSON.parse(localStorage.getItem('userData')))
    history.push('/login')
    ReactGA.pageview('/login')
  }

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  const isRouteWithParam = (route, pathname) => {
    const keys = []
    const regex = pathToRegexp(route, keys)
    const match = regex.exec(pathname)
    return match !== null
  }

  const menuOptions = () => {
    if (showNotificationItem) {
      return MENU_OPTIONS
    } else {
      return MENU_OPTIONS.filter(item => item.title !== 'Avisos')
    }
  }

  return <S.Container>
    <S.MenuList>
      {menuOptions().map(option => {
        if (option.freelanceDisallowed && isFreelance) return <></>
        const isActive = vetRoutesPath[option.ref].some(route =>
          isRouteWithParam(route, pathname)
        )

        return <S.ListItem onClick={() => goToPage(option.url)} key={option.title}>
          <S.Link active={isActive}>
            {(option.title === 'Avisos' && notificationsCount > 0) && <S.NotificationsCount>{notificationsCount}</S.NotificationsCount>}
            {option.icon}
            <S.Title active={isActive}>{option.title}</S.Title>
          </S.Link>
        </S.ListItem>
      })}
    </S.MenuList>
    <S.ButtonLogout onClick={handleLogout} id='logout-button'><LogoutIcon /> Sair</S.ButtonLogout>
  </S.Container>
}

export default SideMenu
